import React from 'react';
import Link from 'next/link';
import Cookies from 'js-cookie';
import { useSearchParams } from 'next/navigation';
import { forwardRef } from 'react';

import { cn } from '@/lib/utils';

interface Props {
  label: string;
  icon: React.ReactNode;
  tab: string;
  close: () => void;
}

export default forwardRef(function HeaderProfileButton(
  { label, icon, tab, close }: Props,
  ref: React.Ref<HTMLAnchorElement>
) {
  const locale = Cookies.get('4TA_LOCALE') ?? 'de-DE';
  const searchParams = useSearchParams();
  const selected = searchParams.get('tab') === tab;

  return (
    <Link
      href={{
        pathname: `/${locale}/account`,
        query: { tab },
      }}
      ref={ref}
      className={cn(
        'relative flex h-[35px] w-full items-center rounded-[30px] text-paragraph transition delay-200'
      )}
      onClick={() => close()}
    >
      {selected && (
        <div className="absolute inset-0 rounded-[30px] bg-primary" />
      )}
      <span
        className={cn(
          'relative z-10 me-[15px] pl-[10px] transition delay-100',
          selected ? 'text-white' : 'text-neutral-400'
        )}
      >
        {icon}
      </span>
      <span
        className={cn(
          'relative z-10 transition delay-100',
          selected && 'text-white'
        )}
      >
        {label}
      </span>
    </Link>
  );
});
